import { z } from 'zod/v4';

import {
  columns,
  constantValueColumns,
  planningLeadTimeColumns,
  rafFixedMarketColumns,
} from './columns';

export const leadTimeConfigBaseSchema = z.object(columns);

export const leadTimeConfigSchema = z.discriminatedUnion('leadTimeType', [
  z.object({ ...columns, ...constantValueColumns.shape }),
  z.object({ ...columns, ...planningLeadTimeColumns.shape }),
  z.object({ ...columns, ...rafFixedMarketColumns.shape }),
]);

export type LeadTimeConfig = z.output<typeof leadTimeConfigSchema>;

export const leadTimeConfigUpdateBaseSchema = leadTimeConfigBaseSchema.pick({
  sortOrder: true,
});

export const leadTimeConfigUpdateSchema = z.discriminatedUnion('leadTimeType', [
  leadTimeConfigUpdateBaseSchema.extend(constantValueColumns.shape),
  leadTimeConfigUpdateBaseSchema.extend(planningLeadTimeColumns.shape),
  leadTimeConfigUpdateBaseSchema.extend(rafFixedMarketColumns.shape),
]);
